import {Button, DatePicker, message, TablePaginationConfig} from "antd";
import {ColumnsType, SorterResult} from "antd/lib/table/interface";
import {wdiCore, WdiModalAppProps} from "@/components/WdiControls";
import React, {Key, useEffect, useState} from "react";
import {WdiModal} from "@/components/WdiControls/WdiModalForm";
import {ResponseStatus} from "@/utils/request";
import {ButtonColumn, FilterColumn, GridFilterForm} from "@/components/GridWidget/GridFilterForm";
import {WdiTable} from "@/components/WdiControls/WdiTable";
import {Pool} from "@/services/sales/financial/pool";
import {WdiSelect} from "@/components/WdiControls/WdiSelect";
import {SoldTo} from "@/services/mdm/soldto";
import moment from "moment";
import {toExcel} from "@/components/WdiControls/WdiExcel";

const {RangePicker} = DatePicker;

type TableParams = {
  pagination: TablePaginationConfig;
  sorter?: SorterResult<any> | null | undefined;
  filterOptions: any,
}
const PoolPrepaySelect: React.FC<WdiModalAppProps> = (props) => {
  const [dataSource, setDataSource] = useState<any>([]);
  const [allDataSource, setAllDataSource] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const {data} = props.data;
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      defaultPageSize: 10,
      total: 0,
      showTotal: (total) => {
        return `共 ${total} 条`;
      },
    },
    sorter: null,
    filterOptions: null,
  });
  const filterColumns: FilterColumn[] = [
    {
      title: '售达方',
      dataIndex: 'soldToCode',
      span: 4,
      render: () => {
        return <WdiSelect {...{
          placeholder: '请选择售达方',
          showSearch: true,
          remote: true,
          dataLoading: async (params) => {
            const response = await SoldTo.ajaxSearch(Object.assign({soldToMasterCode: data.soldToMasterCode}, params));
            return response.data.map((item) => {
              return {value: item.soldToCode, label: item.codeOrName};
            });
          },
        }} />;
      },
    },
    {
      title: '起止年月',
      dataIndex: 'ym',
      span: 8,
      render: () => {
        return <RangePicker allowEmpty={[true, true]} picker='month' style={{width: '100%'}}/>;
      },
    },
  ]
  const columns: ColumnsType<any> = [
    {
      title: '预付编号',
      width: 100,
      dataIndex: 'poolPrepayId',
      ellipsis: true,
    },
    {
      title: '售达方编号',
      width: 120,
      dataIndex: 'soldToCode',
      ellipsis: true,
    },
    {
      title: '售达方名称',
      width: 120,
      dataIndex: 'soldToName',
      ellipsis: true,
    },
    {
      title: '年月',
      width: 100,
      dataIndex: 'ym',
      ellipsis: true,
    },
    {
      title: '预付类型',
      width: 100,
      dataIndex: 'prepayType',
      ellipsis: true,
      render: (text: any) => {
        return text == 1 ? '合同预付' : '活动预付';
      }
    },
    {
      title: '预付金额',
      width: 120,
      dataIndex: 'amountPrepay',
      ellipsis: true,
      render: (text: any) => {
        return text == null ? '' : text.toFixed(2);
      }
    },
  ];
  const doSearch = (filterOptions: any) => {
    fetchData(Object.assign({}, tableParams, {filterOptions}));
  };
  const getFilterOptions = (params: TableParams) => {
    const filterOptions: any = {
      soldToMasterCode: data.soldToMasterCode,
      year: data.year,
      prepayType: data.prepayType,
      isReverse: false,
      isAsc: true
    };
    if (params.filterOptions) {
      const {soldToCode, ym} = params.filterOptions;
      if (!wdiCore.String.IsNullOrEmpty(soldToCode)) {
        filterOptions.soldToCode = soldToCode;
      }
      if (!wdiCore.String.IsNullOrEmpty(ym)) {
        const ymArray: any[] = ym.map((item: any) => {
          return item == null ? null : moment(item).format('YYYYMM');
        });
        filterOptions.startYm = ymArray[0];
        filterOptions.endYm = ymArray[1];
      }
    }
    return filterOptions;
  };
  const fetchData = (params: TableParams) => {
    setLoading(true);
    const filterOptions = getFilterOptions(params);
    const req: API.QueryForPageReq = {
      filterOptions: JSON.stringify(filterOptions),
      pagenum: params.pagination.current ? (params.pagination.current - 1) : 0,
      pagesize: params.pagination.pageSize ? params.pagination.pageSize : 10,
    };
    Pool.queryPoolPrepay(req).then(responseResult => {
      const data = responseResult.data;
      if (data) {
        setDataSource(data.records);
        setTableParams({
          pagination: {
            ...params.pagination,
            total: data.totalCount,
          },
          sorter: params.sorter,
          filterOptions: params.filterOptions,
        });
        setLoading(false);
      }
    });
    const reqAll: API.QueryForPageReq = {
      filterOptions: JSON.stringify(filterOptions),
      pagesize: -1,
      pagenum: -1
    };
    Pool.queryPoolPrepay(reqAll).then(responseResult => {
      const data = responseResult.data;
      if (data) {
        setAllDataSource(data.records);
        setLoading(false);
      }
    });
  };
  const onSelectChange = (newSelectedRowKeys: Key[], newSelectedRows: any[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setSelectedRows(newSelectedRows);
  };
  useEffect(() => {
    fetchData(Object.assign({}, tableParams));
  }, [data]);

  const buttonColumns: ButtonColumn[] = [
    {
      title: '导出',
      key: 'Export',
      doClick: (filterOptions: any) => {
        let columns: any[] = [];
        columns = [
          {name: "poolPrepayId", displayName: "预付编号"},
          {name: "soldToCode", displayName: "售达方编号"},
          {name: "soldToName", displayName: "售达方名称"},
          {name: "prepayType", displayName: "预付类型"},
          {name: "amountPrepay", displayName: "预付金额"},
        ];
        const req: API.QueryForPageReq = {
          filterOptions: JSON.stringify(getFilterOptions(Object.assign({}, tableParams, {filterOptions}))),
          pagenum: 0,
          pagesize: 0
        };
        Pool.queryPoolPrepay(req).then(response => {
          const sheet = {
            data: response?.data?.records,
            names: columns,
            sheetName: "poolPrepay",
            cells: {
              prepayType: (fieldObject: any, row: any, value: any) => {
                return row.prepayType == 1 ? '合同预付' : '活动预付';
              },
            }
          };
          toExcel({
            name: "待冲销的预付信息_" + wdiCore.Date.ToString(new Date()) + ".xlsx",
            sheetProps: [sheet]
          });
        });
      }
    },
  ]
  return (
    <>
      <WdiModal
        title={props.title}
        visible={props.visible}
        width={1400}
        footer={[
          <Button key='onCancel' onClick={() => {
            props.onClose?.();
          }}>
            取消
          </Button>,
          <Button key='allSubmit' type='primary' onClick={() => {
            if (dataSource.length == 0) {
              message.error('请至少添加一条数据');
            } else {
              props.onSave?.({
                code: ResponseStatus.SUCCESS,
                data: allDataSource,
              });
            }
          }}>
            全部添加
          </Button>,
          <Button key='submit' type='primary' onClick={() => {
            if (selectedRows.length == 0) {
              message.error('请至少选择一条数据');
            } else {
              props.onSave?.({
                code: ResponseStatus.SUCCESS,
                data: selectedRows,
              });
            }
          }}>
            添加
          </Button>,
        ]}
        onCancel={() => {
          props.onClose ? props.onClose() : null;
        }}
        maskClosable={false}
        destroyOnClose
      >
        <GridFilterForm columns={filterColumns} doSeach={doSearch} buttonColumns={buttonColumns}/>
        <WdiTable
          columns={columns}
          showPageRows={10}
          rowKey='poolPrepayId'
          dataSource={dataSource}
          rowSelection={{selectedRowKeys, onChange: onSelectChange}}
          pagination={{
            ...tableParams.pagination,
            onChange: (page, pageSize) => {
              fetchData(Object.assign({}, tableParams, {
                pagination: {
                  ...tableParams.pagination,
                  current: page,
                  pageSize: pageSize,
                },
              }));
            },
          }}
          loading={loading}
        />
      </WdiModal>
    </>
  )
}
export default PoolPrepaySelect;
